import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../../../../services/AuthService";
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import ArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import ArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import {
    getCompetences
}from './../../../../../../actions/entreprise/actions_entreprise_entretien';
import AutoComplete from "material-ui/AutoComplete/index";

class CompetencesTable extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            t1Open:false,
            t1AutoComplete:[],
            searchText:''
        };
        this.Auth = new AuthService();
        this.fetchProjetsPro = this.fetchCompetences.bind(this);
        this.deleteProjetPro = this.deleteCompetence.bind(this);
        this.handleNewProjetPro = this.handleNewCompetence.bind(this);
    }

    handleNewCompetence(x){
        const eh = this.props.entretienHeader;
        this.Auth.fetch('/salarie/competences',{
            method:'POST',
            data:{
                id_salarie: eh.id_salarie,
                id_entretien: eh.id,
                id_entreprise: eh.id_entreprise,
                competence:x
            }
        }).then( x=>{
            this.fetchCompetences();
            this.setState({t1Open:true, searchText:''});
        });
    }

    fetchCompetences(){
        const id_entretien = this.props.entretienHeader.id;
        this.props.dispatch(getCompetences(id_entretien));
    }

    deleteCompetence(id_competence){
        this.Auth.fetch(`/salarie/competences/${id_competence}`,{
            method:'delete'
        }).then(x=>this.fetchCompetences());
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.entretienHeader !== this.props.entretienHeader )
            this.fetchCompetences();
    }
    componentDidMount(){
        if(this.props.entretienHeader && this.props.entretienHeader.id){
            this.fetchCompetences();
        }
        this.Auth.fetch('/societe/competences')
            .then(x=> this.setState({t1AutoComplete:x.data.payload}))
    }



    render() {
        return (
            <div>
                <AutoComplete
                    hintText="Compétences mobilisées par le salarié dans son poste actuel"
                    floatingLabelText="Compétences mobilisées"
                    filter={AutoComplete.caseInsensitiveFilter}
                    dataSource={this.state.t1AutoComplete}
                    searchText={this.state.searchText}
                    onUpdateInput={(text)=>this.setState({searchText:text})}
                    onNewRequest={(x)=>this.handleNewCompetence(x)}
                    fullWidth={true}
                    maxSearchResults={5}
                />
                <table className="table table-sm table-hover">
                    <thead className="thead-light" style={{cursor:'pointer'}} onClick={()=>this.setState({t1Open:!this.state.t1Open})}>
                    <tr>
                        <th scope="col">Compétences mobilisées</th>
                        <th width="35" style={{textAlign:'right'}} scope="col">{this.state.t1Open ? <ArrowUpIcon/> : <ArrowDownIcon/>}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.t1Open && this.props.competences.map(x=>{
                        return (
                            <tr key={x.id}>
                                <td>{x.competence}</td>
                                <td style={{textAlign:'right'}}>
                                    <DeleteIcon style={{cursor:'pointer'}} onClick={()=>this.deleteCompetence(x.id)} color='red' />
                                </td>
                            </tr>);
                        })}
                        </tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        competences: store.entretien.competences
    }
}

export default connect(mapStateToProps)(CompetencesTable);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/CompetencesTable.js